/** Calcula intervalo do filtro do dashboard de performance. */
export function resolveDashboardPeriodRange(
  period: string,
  now: Date = new Date()
): { inicioIntervalo: Date; fimIntervalo: Date } {
  const fimIntervalo = new Date(now);

  if (period === 'currentMonth') {
    const inicioIntervalo = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    return { inicioIntervalo, fimIntervalo };
  }

  const days = parseInt(period, 10);
  const inicioIntervalo = new Date(now);
  inicioIntervalo.setDate(inicioIntervalo.getDate() - (Number.isFinite(days) ? days : 30));
  return { inicioIntervalo, fimIntervalo };
}

/** Rótulo amigável do filtro (modal, headers, etc.). */
export function formatDashboardPeriodLabel(period: string): string {
  if (period === 'currentMonth') return 'Mês atual';
  const days = parseInt(period, 10);
  if (Number.isFinite(days)) return `Últimos ${days} dias`;
  return 'Período selecionado';
}
